import { useApiQuery } from '../useApiQuery';
import { depositKeys } from '@/lib/queryKeys';
import { depositEndpoints } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api/client';
import type { DepositListParams, DepositListResponse } from '@/types/deposit';

/** Spec §4 / plan PR 3 — paginated list of deposits with server-side filters. */
export function useDeposits(params: DepositListParams = {}) {
  return useApiQuery<DepositListResponse>({
    queryKey: depositKeys.list(params),
    queryFn: () =>
      apiGet<DepositListResponse>(operationsClient, depositEndpoints.list(), {
        params,
      }),
    showErrorToast: false,
  });
}
